<template>
    <div class="wrap">
        <h1>{{$t('title')}}</h1>
        <div class="log" ref="logbox">
            <div class="logline" v-for="(l,ind) in log" :key="ind" :class="{odd: l.id % 2, even: !(l.id & 2)}">
                {{l.str}}
            </div>
        </div>

        <div class="closeButton">
            <b-button :disabled="!finished" @click="$router.back()">{{$t('close')}}</b-button>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import axios from 'axios';

export default {
  name: 'manualRuleRunner',
  i18nOptions: { keyPrefix: 'rules.manualRuleRunner' },
  data: function() {
    return {
      log: [],
      rules: [],
      currentRule: 0,
      finished: false,
      inboxFolderId: -1
    };
  },
  mounted() {
    this.rules = this.$store.state.settings.manualrules;
    console.log(this.rules);
    const inbox = this.$store.getters.getFolderByName('Inbox');
    if (inbox) {
      this.inboxFolderId = inbox.id;
      this.start();
    } else {
      EventBus.$once('foldersLoaded', () => {
        const inbox = this.$store.getters.getFolderByName('Inbox');
        if (inbox) {
          this.inboxFolderId = inbox.id;
          this.start();
        }
      });
    }
  },
  updated() {
    var logbox = this.$refs.logbox;
    logbox.scrollTop = logbox.clientHeight;
  },
  methods: {
    addLog(id, str) {
      this.log.push({ id, str });
    },
    start() {
      console.log('rule run - start', this.rules.length, this.currentRule);
      if (this.rules.length <= this.currentRule) {
        console.log('rule run - finished');
        this.addLog(this.currentRule, this.$t('finishedRules'));
        this.finished = true;
        EventBus.$emit('messageListRefresh', { folderId: this.$store.getters.getFolderByName('Inbox').id });
      } else {
        const rule = this.rules[this.currentRule];
        if ((rule.conditions.length) && (rule.actions.length)) {
          this.addLog(this.currentRule, this.$t('processRule', { number: this.currentRule + 1, name: rule.name }));
          this.addLog(this.currentRule, this.$t('findMessages'));
          const s = { all: rule.all, conditions: rule.conditions };
          this.$RPC(`folders/${this.inboxFolderId}`, 'search', s)
            .then(d => {
              console.log(d);
              this.addLog(this.currentRule, this.$t('foundMessages', { count: d.uids.length }));
              if (d.uids.length > 0) {
                rule.actions.forEach(a => {
                  const obj = {
                    uids: d.uids
                  };
                  let action = a.action;
                  let actionData = a.data;

                  if (action === 'delete') {
                    const TrashFolderName = this.$store.state.specialFolders['\\Trash'];
                    if (TrashFolderName) {
                      action = 'move';
                      actionData = TrashFolderName;
                    }
                  }

                  switch (action) {
                    case 'move':
                    case 'copy':
                      if (action === 'move') {
                        this.addLog(this.currentRule, this.$t('movingMessages', { folder: actionData,
                          count: d.uids.length }));
                      } else {
                        this.addLog(this.currentRule, this.$t('copyingMessages', { folder: actionData,
                          count: d.uids.length }));
                      }
                      obj.target = this.$store.getters.getFolderByName(actionData);
                      if (obj.target) {
                        obj.target = obj.target.id;
                        this.$RPC(`folders/${this.inboxFolderId}`, action, obj)
                          .then(d => {
                            if (action === 'move') {
                              this.addLog(this.currentRule,
                                this.$t('doneMovingMessages', { folder: actionData, count: obj.uids.length }));
                            } else {
                              this.addLog(this.currentRule,
                                this.$t('doneCopyingMessages', { folder: actionData, count: obj.uids.length }));
                            }
                          })
                          .catch(e => {
                            this.addLog(this.currentRule, this.$t('error', { error: e.message }));
                            this.nextRule();
                          })
                          .finally(() => {
                            this.nextRule();
                          });
                      } else {
                        this.addLog(this.currentRule, this.$t('targetFolderDoesntExist'));
                      }

                      break;

                    case 'markread':
                      obj.value = { read: true };

                      this.addLog(this.currentRule, this.$t('markingRead', { count: d.uids.length }));
                      axios
                        .patch(`/rest/user/folders/${this.inboxFolderId}`, obj)
                        .then(d => {
                          this.addLog(this.currentRule, this.$t('doneMarkingRead', { count: obj.uids.length }));
                        })
                        .catch(e => {
                          this.addLog(this.currentRule, this.$t('error', { error: e.message }));
                          this.nextRule();
                        })
                        .finally(() => {
                          this.nextRule();
                        });
                      break;

                    case 'markunread':
                      obj.value = { read: false };

                      this.addLog(this.currentRule, this.$t('markingUnread', { count: d.uids.length }));
                      axios
                        .patch(`/rest/user/folders/${this.inboxFolderId}`, obj)
                        .then(d => {
                          this.addLog(this.currentRule, this.$t('doneMarkingUnread', { count: obj.uids.length }));
                        })
                        .catch(e => {
                          this.addLog(this.currentRule, this.$t('error', { error: e.message }));
                          this.nextRule();
                        })
                        .finally(() => {
                          this.nextRule();
                        });
                      break;

                    case 'flag':
                      obj.value = { flagged: true };

                      this.addLog(this.currentRule, this.$t('markingFlagged', { count: d.uids.length }));
                      axios
                        .patch(`/rest/user/folders/${this.inboxFolderId}`, obj)
                        .then(d => {
                          this.addLog(this.currentRule, this.$t('doneMarkingFlagged', { count: obj.uids.length }));
                        })
                        .catch(e => {
                          this.addLog(this.currentRule, this.$t('error', { error: e.message }));
                          this.nextRule();
                        })
                        .finally(() => {
                          this.nextRule();
                        });
                      break;

                    case 'delete':
                      obj.value = { deleted: true, read: true };

                      this.addLog(this.currentRule, this.$t('deleting', { count: d.uids.length }));
                      axios
                        .patch(`/rest/user/folders/${this.inboxFolderId}`, obj)
                        .then(d => {
                          this.addLog(this.currentRule, this.$t('doneDeleting', { count: obj.uids.length }));
                        })
                        .catch(e => {
                          this.addLog(this.currentRule, this.$t('error', { error: e.message }));
                          this.nextRule();
                        })
                        .finally(() => {
                          this.nextRule();
                        });
                      break;
                  }
                });
              } else {
                this.nextRule();
              }
            })
            .catch(e => {
              this.addLog(this.currentRule, this.$t('error', { error: e.message }));
              this.nextRule();
            });
        } else {
          this.addLog(this.currentRule, this.$t('skipRule', { number: this.currentRule + 1, name: rule.name }));
          this.nextRule();
        }
      }
    },
    nextRule() {
      this.currentRule++;
      this.start();
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .wrap {
        display: flex;
        flex-direction: column;
        padding: 10px;
        height: 100%;
        h1 {
            flex: 0 0 auto;
        }
        .log {
            flex: 1;
            overflow-y: scroll;
            border-radius: 10px;
            .logline {
                background-color: $table-stripe2;
                padding: 0 10px;
                &.odd {
                    background-color: $table-stripe;
                }
            }
        }
        .closeButton {
          flex: 0 0 auto;
        }
    }

</style>
